import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { IoMdClose } from "react-icons/io";

const Modal = ({ isOpen, onClose, children }) => {
    const modalRef = useRef();

    // Effect to handle closing the modal when clicking outside of it
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, onClose]);

    // Don't render anything if the modal is not open
    if (!isOpen) {
        return null;
    }

    return createPortal(
        <div className="cabana-modal modal-overlay">
            <div className="modal-content" ref={modalRef}>
                <button onClick={onClose} className="modal-close-button">
                    <IoMdClose size={16} />
                </button>
                {children}
            </div>
        </div>,
        document.body
    );
};

export default Modal;